import { WifiNetworkType } from "../../components/settings/DeviceSettings.types";

export const wifiNetworkTypes: WifiNetworkType[] = [
  "OPEN",
  "WEP",
  "WPA",
  "WPA3",
];
